import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useFiardleStats(userId?: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.fiardle.stats(),
    queryFn: () => api.getFiardleStats(userId),
  });

  return {
    stats: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to fetch stats' : null,
    refetch: () => {
      refetch();
    },
  };
}
